define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/xml",
	"./VersionTableView"
], function(declare,_,xml,VersionTableView) {

	function _hasChildren(/*Context*/ctx) {
		var node = ctx.getNode();
		return (node.$Type != "MerchCollectionVersion") && node.Children.length;
	}

	function _onCreateStore(store, bConfigurable, ql) {
		store.typeNode = null;
	}

	return declare(VersionTableView, {
		_createQueryResult: function(/*Object*/params) {
			// summary: override id of query results with version-less url to support expanding table to same level when switching seasons
			if (!params.id) {
				var node = this.cacheView.getNode(params.url);
				if (node && node.Parents && xml.isValidURL(node.__Parent__)) {
					params.id = node.__Parent__;
				}
			}

			return this.inherited(arguments);
		},

		_onCreateQueryLevels: function(/*QueryLevel[]*/queryLevels) {
			// summary: extension point to react to change in query levels

			// unset type on store because the merchandising hierarchy is flexible (can have multiple levels of folders)
			queryLevels[1].onCreateStore = _onCreateStore;
			queryLevels[1].hasChildrenTest = _hasChildren;

			this.inherited(arguments);

		}
	});
});
